<template lang="pug">
  v-combobox(v-model='model' :filter='filter' :hide-no-data='!search' :items='registro_de_etiquetas' :search-input.sync='search' hide-selected label='Selecciona una etiqueta' multiple small-chips rounded outlined)
    template(v-slot:no-data)
      v-list-item
        span.subheading Crear 
        v-chip( small ).ml-2 {{ search }}
    template(v-slot:selection='{ attrs, item, parent, selected }')
      v-chip( small)
        span.pr-2 {{ item }} 
        v-icon(x-small @click='parent.selectItem(item)') fa-times
    template(v-slot:item='{ index, item }')
      v-list-item-title {{ item }}
      v-spacer
      v-list-item-action(@click.stop)
        v-btn(icon @click.stop.prevent='eliminar(item)')
          v-icon(small) far fa-trash-alt

</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  
  
  computed: mapGetters({
    registro_de_etiquetas: 'Etiquetas/registro'
  }),
  data: () => ({
    activator: null,
    attach: null,
    
    editing: null,
    index: -1,
    nonce: 1,
    menu: false,
    model: [],
    x: 0,
    search: null,
    y: 0,
  }),

  watch: {
    model (val, prev) {
      if (val.length === prev.length) return
      this.model = val.map(v => {
        if (typeof v === 'string')  this.agregar(v)
        return v
      })
      this.$emit('_etiquetas', this.model)
    },
    etiquetas(){
      this.model = this.etiquetas
    }
  },
  methods: {
    edit (index, item) {
      if (!this.editing) {
        this.editing = item
        this.index = index
      } else {
        this.editing = null
        this.index = -1
      }
    },
    filter (item, queryText, itemText) {
      if (item.header) return false

      const hasValue = val => val != null ? val : ''

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1
    },
    ...mapActions({
      agregar: 'Etiquetas/agregar',
      eliminar: 'Etiquetas/eliminar',
    })
  },
  props: {
    etiquetas: Array
  }
}
</script>